import { render, staticRenderFns } from "./PaygroupsIntro.vue?vue&type=template&id=67e06000&scoped=true"
import script from "./PaygroupsIntro.vue?vue&type=script&lang=js"
export * from "./PaygroupsIntro.vue?vue&type=script&lang=js"
import style0 from "./PaygroupsIntro.vue?vue&type=style&index=0&id=67e06000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e06000",
  null
  
)

export default component.exports